export type EvaChurchView = {
  publicId: string;
  name: string;
  isBulletinSend: boolean;
};

export type EvaSyncPreflightBulletinView = {
  evaEnabled: boolean;
  mpaConfigured: boolean;
  canInclude: boolean;
};

export type EvaSyncPreflightRequest = {
  evaPublicId: string;
};

export type EvaSyncPreflightResponse = {
  evaChurch: EvaChurchView;
  bulletin: EvaSyncPreflightBulletinView;
};

export enum EVA_SYNC_BULLETIN_MODE {
  INCLUDE = 'include',
  SKIP = 'skip',
}

export enum EVA_SYNC_RUN_STATUS {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  COMPLETED_WITH_WARNINGS = 'completed_with_warnings',
  COMPLETED_WITH_ERRORS = 'completed_with_errors',
  FAILED = 'failed',
}

export const EVA_SYNC_RUN_IN_PROGRESS_STATUSES: EVA_SYNC_RUN_STATUS[] = [
  EVA_SYNC_RUN_STATUS.PENDING,
  EVA_SYNC_RUN_STATUS.PROCESSING,
];

export const EVA_SYNC_RUN_STATUS_LABELS: Record<EVA_SYNC_RUN_STATUS, string> = {
  [EVA_SYNC_RUN_STATUS.PENDING]: 'Pending',
  [EVA_SYNC_RUN_STATUS.PROCESSING]: 'Processing',
  [EVA_SYNC_RUN_STATUS.COMPLETED]: 'Completed',
  [EVA_SYNC_RUN_STATUS.COMPLETED_WITH_WARNINGS]: 'Completed with warnings',
  [EVA_SYNC_RUN_STATUS.COMPLETED_WITH_ERRORS]: 'Completed with errors',
  [EVA_SYNC_RUN_STATUS.FAILED]: 'Failed',
};

export const EVA_SYNC_BULLETIN_MODE_LABELS: Record<EVA_SYNC_BULLETIN_MODE, string> = {
  [EVA_SYNC_BULLETIN_MODE.INCLUDE]: 'Include',
  [EVA_SYNC_BULLETIN_MODE.SKIP]: 'Skip',
};

export const isEvaSyncRunInProgress = (status: EVA_SYNC_RUN_STATUS): boolean =>
  EVA_SYNC_RUN_IN_PROGRESS_STATUSES.includes(status);

export type EvaSyncRunCreateRequest = {
  evaPublicId: string;
  bulletinMode: EVA_SYNC_BULLETIN_MODE;
};

export type EvaSyncRunCountersView = {
  groupsTotal: number;
  groupsCreated: number;
  groupsExisting: number;
  membersTotal: number;
  membersCreated: number;
  membersExisting: number;
  membersFailed: number;
  roleWarnings: number;
};

export type EvaSyncRunListing = {
  hasReport: boolean;
  status: EVA_SYNC_RUN_STATUS;
  bulletinMode: EVA_SYNC_BULLETIN_MODE;
  id: string;
  evaPublicId: string;
  counters: EvaSyncRunCountersView;
  reportPath: string | null;
  errorCode: string | null;
  errorMessage: string | null;
  startedAt: string | null;
  finishedAt: string | null;
  createdDate: string;
};

export type EvaSyncRunView = {
  id: string;
  churchId: string;
  evaPublicId: string;
  status: EVA_SYNC_RUN_STATUS;
  bulletinMode: EVA_SYNC_BULLETIN_MODE;
  preflightSnapshot: Record<string, unknown>;
  counters: EvaSyncRunCountersView | Record<string, unknown>;
  reportPath: string | null;
  errorCode: string | null;
  errorMessage: string | null;
  startedAt: string | null;
  finishedAt: string | null;
};
